/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TombstoneRip} from "../../TombstoneRip";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TombstoneRipSymbol} from "../../symbol/TombstoneRipSymbol";

export class WildLandingController extends ReelStopPresentationController {

    private _animations:TimelineLite[] = [];

    constructor() {
        super("WildLandingController");
    }

    protected async onReelBounce(data:IReelStateEventData):Promise<any> {
        const promises:Promise<any>[] = [];
        const symbols:TombstoneRipSymbol[] = [];
        TombstoneRip.model.reels[data.reelId].forEach((symName, symIndex) => {
            if(symName.includes("W") && TombstoneRip.reels[data.reelId].isDataSymbolInValidArea(symIndex)) {
                const symbol = TombstoneRip.reels[data.reelId].getSymbol(symIndex, true);
                if(!symbols.includes(symbol)) {
                    symbols.push(symbol);
                    const ani = symbol.playLanding();
                    this._animations.push(ani);
                    promises.push(Promise.resolve(ani).then(res => {
                        ArrayHelper.removeFirstMatchElement(this._animations, ani);
                    }));
                }
            }
        });
        await Promise.all(promises);
        symbols.length = 0;
    }

    public skip() {
        super.skip();
    }
}